import { useEffect, useState } from "react";
import { loadRainforestPayScript } from "../utils/loadRainforestPayScript";

export function useRainforestPay() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadRainforestPayScript()
      .then(() => {
        if (!cancelled) setReady(true);
      })
      .catch(error => {
        // Without this the rejection goes unhandled and the payment component
        // never gets defined, leaving the form silently unusable
        console.error("Rainforest Pay script failed to load", error);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return ready;
}
